import { useMemo } from 'react';
import { useAppSelector } from '../store/useStore';

export const useGetDownloadAppModalHeight = (): number => {
  const globalTooltipStates = useAppSelector((state) => state.globalTooltip);

  const downloadAppModalHeight = useMemo<number>(() => {
    let downloadAppModalHeight = 0;

    if (globalTooltipStates.isShowAnyTooltip && globalTooltipStates.isShowDownloadAppModal) {
      downloadAppModalHeight = globalTooltipStates.downloadAppTooltipHeight;
    }

    return downloadAppModalHeight;
  }, [globalTooltipStates.isShowAnyTooltip, globalTooltipStates.isShowDownloadAppModal]);

  return downloadAppModalHeight;
};
